<script>
import { mapGetters } from 'vuex';
/* eslint-disable import/no-extraneous-dependencies */
import CommonSharedMdm from '@common/mixins/CommonSharedMdm';
import { mdmType } from '@common/constants/mdm';
import {
  MDMMenu,
  hideSearch,
  actionButtons,
  defaultSearchParameters,
} from '@/constants/mdm-v2/header';
import { listHeaders } from '@/constants/mdm-v2/listConstants';
import { uploadSampleFileName } from '@/constants/mdm-v2/uploadConstants';
import { formConstants } from '@/constants/mdm-v2/formConstants';
import { searchConstants } from '@/constants/mdm-v2/searchConstants';

const MDM = {
  mixins: [CommonSharedMdm],
  data() {
    return {
      // following are imports from mdm constants file
      Menu: MDMMenu,
      defaultSearchParameters,
      hideSearch,
      actionButtons,
      mdmType,
      listHeaders,
      uploadSampleFileName,
      formConstants,
      defaultValues: {}, // default values to be shown in the input fields
      searchedParams: {}, // user input data
      searchConstants,
    };
  },
  computed: {
    ...mapGetters({
      isPaginating: 'mdmV2/isPaginating',
      isUploading: 'mdmV2/isUploading',
      filter: 'mdmV2/filter',
      isLoading: 'mdmV2/isLoading',
      list: 'mdmV2/list',
      hasEmpty: 'mdmV2/hasEmpty',
      configurations: 'app/currentClientConfig',
    }),
  },
};
export default MDM;
</script>
